export default __webpack_public_path__ + "static/media/Section1-subsvg.ed0ab8c4.svg";